import classNames from 'classnames/bind';
import PropTypes from 'prop-types';
import Moment from 'react-moment';
import { i18n } from 'common';

import React from 'react';
import { Form, Input, Textarea, CheckboxGroup, Select } from 'formsy-react-components';

export const AdminInput = (props) => (
  <div className="f-group admin-group">
    <Input {...props} className="w90" layout="vertical" />
  </div>
)

export const AdminUrlInput = (props) => (
  <AdminInput {...props} validations="isUrl" validationError="Supports only URL formats" />
)

export const AdminTextArea = (props) => (
  <div className="f-group admin-group">
    <Textarea {...props} className="w90" layout="vertical" />
  </div>
)

export const AdminSelect = (props) => (
  <div className="f-group admin-group">
    <Select {...props} className="w80" layout="vertical" />
  </div>
)

export const AdminButton = ({className, type="submit", ...rest}) => {
  switch (type) {
    case 'submit':
      return (
        <input {...rest} className={classNames("btn btn--primary", className)}
               formNoValidate type="submit" defaultValue={i18n('control.button.submit')} />
      );

    case 'cancel':
      return (
        <input {...rest} className="btn btn--action"
               type="button" defaultValue={i18n('control.button.cancel')} />
      );

    case 'reset':
      return (
        <input {...rest} className="btn btn--danger"
               type="reset" defaultValue={i18n('control.button.reset')} />
      );
  }

  return (<div></div>);
}
